import { helper } from '@ember/component/helper';

// regex to detect emojis at the beginning of the string
const _BEGINNING_EMOJI_REGEX = /^[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u;

export function hasLeadingEmoji(text?: string): boolean {
	if (!text) {
		return false;
	}

	return _BEGINNING_EMOJI_REGEX.test(text);
}

export function getLeadingEmoji(text: string): string {
	const emojiMatch = _BEGINNING_EMOJI_REGEX.exec(text);
	return emojiMatch ? emojiMatch[0] : '';
}

export function emoji(
	_params: void[],
	hash: {
		text: string;
		mode: 'emoji' | 'displayText';
	},
) {
	const { text, mode } = hash;

	if (!text) {
		return '';
	}

	const emojiMatch = _BEGINNING_EMOJI_REGEX.exec(text);
	const beginningEmoji = emojiMatch ? emojiMatch[0] : null;

	if (mode === 'emoji') {
		return beginningEmoji || '';
	}

	// mode === 'displayText'
	return beginningEmoji ? text.replace(beginningEmoji, '').trim() : text;
}

const emojiHelper = helper(emoji);

export default emojiHelper;
